import { createTheme } from '@material-ui/core';

export default createTheme({
  palette: {
    success: {
      main: '#00A142',
      contrastText: '#fff',
    },
    warning: {
      main: '#E35D7D',
      contrastText: '#fff',
    },
    info: {
      main: '#2A88FF',
      contrastText: '#fff',
    },
    error: {
      main: '#FFDD82',
      contrastText: '#292929',
    },
  },
});
